import {APIService} from "../../common/APIService";
import {CompletedAddress} from "../../dto/CompletedAddress";

export class AddressService extends APIService {
  public async lookup(zipcode: string, number: number): Promise<CompletedAddress> {
    const json = await this.postJson<{data: object}>(`complete_address`, {
      zipcode: zipcode,
      number: number,
    })
    return CompletedAddress.fromJson(json.data)
  }
}